import { AxiosRequestConfig } from 'axios'
import { AxiosService } from '@/shared/utils'
import { LoginDataType } from '@/shared/types'
import { useOrganizationModules } from '@/shared/composables'

class AuthApi extends AxiosService {
  constructor(config?: AxiosRequestConfig) {
    super(config)
  }

  public login(user: LoginDataType) {
    const { email, password } = user

    return this.axiosCall({
      method: 'post',
      url: '/api/web/login',
      data: {
        login: email,
        password,
      },
    })
  }

  public logout() {
    return this.axiosCall({
      method: 'get',
      url: '/api/web/logout',
    })
  }

  public getOrganizations() {
    return this.axiosCall({
      method: 'get',
      url: '/api/web/admin/users/get-organizations',
    })
  }

  public async setOrganization(organizationId: number) {
    const [setOrganizationError, setOrganizationResponse] =
      await this.axiosCall({
        method: 'post',
        url: '/api/web/admin/users/set-organization',
        params: {
          organization_id: organizationId,
        },
      })

    if (setOrganizationError) {
      return
    }

    await this.getOrganizationModules(organizationId)

    return [setOrganizationError, setOrganizationResponse]
  }

  public async getOrganizationModules(organizationId: number) {
    const [getOrganizationError, getOrganizationResponse] =
      await this.axiosCall({
        method: 'get',
        url: `/api/web/admin/organizations/${organizationId}`,
      })
    if (getOrganizationError) {
      return
    }
    const { updateOrganizationModules } = useOrganizationModules()
    updateOrganizationModules(getOrganizationResponse.data.organization.modules)
  }
}

export const authApi = new AuthApi({
  baseURL:
    process.env.NODE_ENV === 'production' ? process.env.VUE_APP_BASE_URI : '',
  withCredentials: true,
})
